<template>
  <ErrorList
    id="serverErrorValidationMessages"
    :title="title ?? $localize('ServerSideValidationFailed')"
    :errors="errors"
    :show-horizontal-rule="true"
    data-test="server-error-validation-messages"
  />
</template>

<script lang="ts" setup>
  import ErrorList from '@/VueComponents/SharedComponents/ErrorList/ErrorList.vue';

  defineProps<{
    errors?: string[],
    title?: string
  }>();
</script>
